import { Component, OnInit, Input, ChangeDetectorRef, Inject, EventEmitter, OnDestroy } from '@angular/core';
import { ConfiguracionEmpresaService } from '../../../providers/configuracion-empresa.service';
import { GeneralService } from '../../../providers/general.service';
import { MatDialog, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LandingService } from '../../../providers/landing.service';
import { FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CKEditor4 } from 'ckeditor4-angular';

@Component({
  selector: 'app-crear-landing',
  templateUrl: './crear-landing.component.html',
  styleUrls: ['./crear-landing.component.scss'],

})
export class CrearLandingComponent implements OnInit {
  IdLanding: any;

  constructor(
    private _fb: FormBuilder,
    private _landingSv: LandingService,
    private cd: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private _generalSv: GeneralService,
    private _confSv: ConfiguracionEmpresaService,
    private _route: ActivatedRoute,
    private _router: Router,

  ) {
    // esto x si elimina la imagen recargamos la landing
    this._landingSv.deleteI.subscribe((resp) => {
      this.inicializar();
    })
  }

  object: any;

  cargando: boolean[] = [];
  logoConf: any;
  carouselNoImg_ = ["./assets/imagenes/unnamed.jpg", "./assets/imagenes/unnamed.jpg"]
  base64Image: string = '';
  base64Meta: string = '';
  logo_width = "15%";
  colorBoton = "#0e9ae5";
  color_nombre_empresa = "#333";
  colorFuenteBoton = "#fff";
  varlidarImgCarousel = []
  colorFuente = "#585858";
  colorBotonesRedes: "#333";

  title = "Título de la landing";
  color_fuente_descripcion = "#585858";
  description = "Descripcion de la landing";
  imagen_width = "25%";
  base64Logo: string = '';
  img_defecto = "./assets/imagenes/unnamed.jpg";
  background_default = './assets/landing/img/background-header.svg';
  // background_default = 'https://flevix.com/wp-content/uploads/2020/01/Shadow-Fall-Background.svg';
  bse64ImagenCarousel = [];
  campos: any;
  array: any;
  landing_id: number;
  editar: boolean;
  background = "default";
  link = this._generalSv.web;
  imagen_formulario = true;
  campana_venta_id: number;
  posiciones: any;
  imagenes_id = [];
  formLanding = this._fb.group({
    titulo: [null, Validators.required],
    descripcion: [null, Validators.required],
    imagenes: [],
    employees: this._fb.array([this.camposDisponibles()]),
    redesSociales: this._fb.group({
      facebook: '',
      instagram: '',
      twitter: '',
      web: ''
    }),
    logo_tamanio: [15],
    imagen_tamanio: [25],
    color_boton: ["#0e9ae5"],
    color_fuente: ["#585858"],
    color_boton_fuente: ["#fff"],
    imagen_formulario: [true],
    sin_fondo: [false],
    posicionTitulo: [],
    posicionDescripcion: [3],
    posicionLogo: [3],
    posicionFormulario: [],
    posicionFondo: [7],
    posicionBoton: [2],
    posicionMeta: [8],
    posicionRedesSociales: [1],
    colorBotonesRedes: ["#333"],
    nombre_empresa: [null],
    nombre_empresa_tamanio: [50],
    boton_whatsapp: [null],
    posicionBotonWhatsapp: [4],
    numero_contacto_whatsapp: [null],
    color_boton_whatsapp: [null],
    imagenes_carousel: [true],
    fuente_titulo_tamanio: [20],
    circulo_tamanio_whatsapp: [60],
    logo_whatsapp_tamanio: [35],
    fuente_descripcion_tamanio: [18],
    fuente_bold_descripcion: [false],
    fuente_subrayar_descripcion: [false],
    posicionTextoDescripcion: [6]


  })
  // Posiciones default de landing
  posicionTituloD = "6"; //Abajo
  posicionLogoD = "3"; //izquierda
  posicionDescripcionD = "2"; //Abajo
  posicionFormularioD = "4";  //Derecha
  posicionRedesD = "4";//Derecha
  posicionBotonWhatsappD = "4";//Derecha
  posicionTextoDescripcionD = "6";
  nombre_empresa_string: any;
  nombre_empresa_boolean = true;
  nombre_empresa_tamanio: any;
  color_boton_whatsapp = "#25d366";
  activar_boton_whatsapp: boolean = true;
  color_formulario_fondo = "#fff";
  color_fondo_input = "#ECF0F1";
  color_boton_twitter = "#1da1f2";
  color_boton_facebook = "#3b5998";
  color_boton_instagram = "#c44e4e";
  color_boton_web = "#36adad";

  ngOnInit() {
    this.inicializar()
  }
  inicializar() {
    this._route.params.subscribe(params => {
      if (params['campana_venta_id']) {
        this.campana_venta_id = params['campana_venta_id'];
      }
      if (params['landing_id']) {
        this.landing_id = params['landing_id'];
        this.editar = true;
      }
    });
    this.getConfiguracion();

  }
  // Obtengo el logo de la empresa en caso de que tenga lo pongo directamente en la landing de muestra
  getConfiguracion() {
    this.cargando.push(true)
    this._confSv.getConfiguracion().subscribe(
      respuesta => {
        if (respuesta.data) {
          this.nombre_empresa_string = respuesta.data.razon_social;
          this.logoConf = respuesta.data.logo;
        }
        if (this.editar) {
          this.getLanding()
        }
        this.getPosiciones();
      },
      () => {
        this.cargando.pop()
      },
      () => {
        this.cargando.pop()
      },
    )
  }

  // obtengo la landing al editar
  getLanding() {
    this.cargando.push(true);
    const model = {
      filtros: {
        id: this.landing_id
      }
    }
    this._landingSv.getLanding(model).subscribe((respuesta) => {
      this.setValoresEditar(respuesta);
    })
  }

  // seteamos valores al editar
  respuesta: any;
  setValoresEditar(resp) {
    this.bse64ImagenCarousel = [];
    this.varlidarImgCarousel.pop();
    this.respuesta = resp.data[0];
    this.formLanding.controls['titulo'].setValue(this.respuesta.titulo);
    this.formLanding.controls['descripcion'].setValue(this.respuesta.descripcion);
    this.respuesta.landing_configuracion.forEach(element => {
      var parse = JSON.parse(element.configuracion);
      switch (parse.elemento) {
        case 'logo':
          // width
          this.formLanding.controls['logo_tamanio'].setValue(parseInt(parse.data.configuracion.width))
          this.logo_width = parse.data.configuracion.width;
          // posiciones
          this.posicionLogoD = parse.data.posicion_id;
          this.formLanding.controls['posicionLogo'].setValue(this.posicionLogoD);
          this.posDiv(parse.elemento, parse.data.posicion_id);
          break;
        case 'titulo':
          //posiciones
          this.posicionTituloD = parse.data.posicion_id;
          this.posDiv(parse.elemento, parse.data.posicion_id);
          // style
          this.colorFuente = parse.data.configuracion.color;
          this.formLanding.controls['color_fuente'].setValue(parse.data.configuracion.color);
          // console.log(parse.data.configuracion.fuente_tamanio, "fuente tamaño")
          this.formLanding.controls['fuente_titulo_tamanio'].setValue(parse.data.configuracion.fuente_tamanio);
          break;
        case 'descripcion':
          // texto dentro de la descripcion
          this.posicionTextoDescripcionD = parse.data.posicion_id;
          // style
          this.formLanding.controls['fuente_descripcion_tamanio'].setValue(parse.data.configuracion.texto.font_size);
          this.formLanding.controls['fuente_bold_descripcion'].setValue(parse.data.configuracion.texto.bold)
          this.formLanding.controls['fuente_subrayar_descripcion'].setValue(parse.data.configuracion.texto.underline);
          this.posDiv("texto_descripcion", parse.data.posicion_id);
          this.color_fuente_descripcion = parse.data.configuracion.texto.color;
          break;
        case 'boton':
          // style boton
          this.colorFuenteBoton = parse.data.configuracion.color;
          this.formLanding.controls['color_boton_fuente'].setValue(this.colorFuenteBoton);
          this.colorBoton = parse.data.configuracion.background;
          this.formLanding.controls['color_boton'].setValue(this.colorBoton);
          break;
        case 'fondo':
          if (parse.data.configuracion.background != "default") {
            this.background = parse.data.configuracion.background;
          }
          break;
        case 'formulario':
          this.posicionFormularioD = parse.data.posicion_id;
          this.color_formulario_fondo = parse.data.configuracion.background;
          this.color_fondo_input = parse.data.configuracion.input.background;
          this.posDiv(parse.elemento, parse.data.posicion_id);
          this.imagen_formulario = parse.data.imagen.imagen_activar;
          this.formLanding.controls['imagen_formulario'].setValue(this.imagen_formulario)
          this.imagen_width = parse.data.imagen.configuracion.width ? parse.data.imagen.configuracion.width : '';
          this.formLanding.controls['imagen_tamanio'].setValue(parseInt(this.imagen_width));
          break;
        case 'redes':
          this.posicionRedesD = parse.data.posicion_id;
          this.posDiv(parse.elemento, parse.data.posicion_id);
          // style
          this.color_boton_facebook = parse.data.configuracion.redes.facebook;
          this.color_boton_instagram = parse.data.configuracion.redes.twitter;
          this.color_boton_twitter = parse.data.configuracion.redes.instagram;
          this.color_boton_web = parse.data.configuracion.redes.web;
          break;
        case 'whatsapp':
          this.posicionBotonWhatsappD = parse.data.posicion_id;
          this.formLanding.controls['color_boton_whatsapp'].setValue(parse.data.configuracion.color);
          this.color_boton_whatsapp = parse.data.configuracion.color;
          this.formLanding.controls['boton_whatsapp'].setValue(parse.data.configuracion.activar);
          this.formLanding.controls['numero_contacto_whatsapp'].setValue(parse.data.configuracion.numero);
          this.posDiv(parse.elemento, parse.data.posicion_id);
          this.formLanding.controls['circulo_tamanio_whatsapp'].setValue(parse.data.configuracion.circulo.width);
          this.formLanding.controls['logo_whatsapp_tamanio'].setValue(parse.data.configuracion.logo.width);
          break;
        case 'nombre_empresa':
          this.color_nombre_empresa = parse.data.configuracion.color;
          this.nombre_empresa_tamanio = parse.data.configuracion.width + "px";
          this.formLanding.controls['nombre_empresa'].setValue(parse.data.configuracion.activar);
          this.formLanding.controls['nombre_empresa_tamanio'].setValue(parse.data.configuracion.width);
          break;
      }
    });
    // seteo los valores de imagenes
    resp.data[0].imagenes.forEach(element => {
      if (element.tipo == 'logo') {
        this.logoConf = element.blob;
      }
      else if (element.tipo == 'carousel') {
        this.varlidarImgCarousel.push(true);
        this.bse64ImagenCarousel.push(element.blob)
      }
      else if (element.tipo == 'formulario') {
        this.base64Image = element.blob
      }
    });
    // redes sociales
    this.respuesta.redes_sociales.forEach(element => {
      let redSocial = element.nombre;
      let url = element.url;
      let redesSociales = [];
      redesSociales.push({
        redSocial: url
      })
      this.formLanding.get(['redesSociales', redSocial]).setValue(url);
    });
  }
  ngOnDestroy() {
    // me desuscribo cuando me voy
    // this._landingSv.dele.unsubscribe();
  }
  i = 0;

  getSlide() {
    return this.bse64ImagenCarousel[this.i];
  }

  getPrev() {
    this.i = this.i === 0 ? 0 : this.i - 1;
  }
  //edit here
  getNext() {
    this.i = this.i === this.bse64ImagenCarousel.length ? this.i : this.i + 1;
  }

  // Sacar el fondo del la landing
  sin_fondo() {
    if (this.formLanding.controls['sin_fondo'].value)
      this.background = null;
    else
      this.background = 'default'
  }

  // eliminar fondo logo y imagen de formulario según lo que quiera el usuario
  eliminar(param?) {
    switch (param) {
      case 'logo':
        this.base64Logo = '';
        break;
      case 'imagenes':
        this.base64Image = ''
        break;
      case 'fondo':
        this.background = null;
        break;
      case 'meta':
        this.base64Meta = null;
        break;
      case 'carousel':
        this.bse64ImagenCarousel = [];
        break;
    }
    this.snackBar.open("Imagen eliminada correctamente", 'OK', { duration: 2750 });
  }

  // Carga de imagenes
  upload(ev, param?) {
    switch (param) {
      case 'logo':
        this.base64Logo = ev.src;
        break;
      case 'imagenes':
        this.base64Image = ev.src;
        break;
      case 'fondo':
        this.background = ev.src;
        break;
      case 'meta':
        this.base64Meta = ev.src;
        break;
      case 'carousel':
        this.bse64ImagenCarousel.push(
          ev.src
        );
        break;
    }
  }
  //esconder checkbox
  campos_disabled(e, value) {
    this.campos.forEach(campos => {
      if (campos.nombre == value) {
        if (!e.checked) {
          var element: HTMLElement = document.getElementsByClassName(value)[0] as HTMLElement;
          element.style.display = "none";
        } else {
          var element: HTMLElement = document.getElementsByClassName(value)[0] as HTMLElement;
          element.style.display = "block";
        }
      }
    });
  }
  // checkbox de formulario
  camposDisponibles() {
    const respuestaCampos = this._fb.group({});
    this._landingSv.getCamposDisponibles("").subscribe(
      respuesta => {
        this.campos = respuesta.data
        this.campos.forEach(apiRespuesta => {
          respuestaCampos.addControl(apiRespuesta.nombre, this._fb.control([]));
        });
      }
    );
    return respuestaCampos;
  }
  // esto es para los campos (inputs de formulario)
  addEmployerToFormArray() {
    this.employeeRows.push(this.camposDisponibles());
  }

  // esto es para los campos (inputs de formulario)
  get employeeRows() {
    return (<FormArray>this.formLanding.get('employees'));
  }

  // descripcion
  ckeditor(event: CKEditor4.EventInfo) {
    this.description = event.editor.getData();
  }

  // Funcion que envia todo al servidor
  submit() {
    this.cargando.push(true);
    if (this.editar) {
      this.object =
      {
        "landing": {
          "titulo": this.formLanding.controls['titulo'].value,
          "descripcion": this.formLanding.controls['descripcion'].value,
          "id": this.landing_id
        },
      }
    } else {
      this.object =
      {
        "landing": {
          "titulo": this.formLanding.controls['titulo'].value,
          "descripcion": this.formLanding.controls['descripcion'].value,
          "campania_venta_id": this.campana_venta_id
        },
      }
    }
    this.object["landing_campos"] = [];
    this.object['landing_imagenes'] = [];
    this.object['landing_redes_sociales'] = [];
    this.object['configuracion'] = [];
    this.formLanding.controls['employees'].value.forEach(campos => {
      this.campos.forEach(apiCampos => {
        if (campos[apiCampos["nombre"]]) {
          this.object["landing_campos"].push({
            "landing_campo_disponible_id": apiCampos["id"],
            "nombre": apiCampos["nombre"]
          });
        }
      });
    });
    if (this.base64Image) {
      this.object['landing_imagenes'].push({
        "nombre": "img_formulario",
        "blob": this.base64Image,
        'tipo': 'formulario'
      });
    }
    if (this.base64Logo != '') {
      this.object['landing_imagenes'].push({
        "nombre": "img_logo",
        "blob": this.base64Logo,
        'tipo': 'logo'
      });
    } else if (this.logoConf != '') {
      this.object['landing_imagenes'].push({
        "nombre": "img_logo",
        "blob": this.logoConf,
        'tipo': 'logo'
      });
    }
    if (this.base64Meta || this.logoConf) {
      this.object['landing_imagenes'].push({
        "nombre": "img_meta",
        "blob": this.base64Meta ? this.base64Meta : this.logoConf,
        'tipo': 'meta'
      });
    }
    if (this.bse64ImagenCarousel.length > 0) {
      var i = 0;
      this.bse64ImagenCarousel.forEach(element => {
        this.object['landing_imagenes'].push({
          "nombre": "img_carousel" + i++,
          "blob": element,
          'tipo': 'carousel'
        });
      });
    }
    // posiciones y configuracion
    this.object['configuracion'] = {
      "formulario": {
        "posicion_id": this.formLanding.controls['posicionFormulario'].value,
        "imagen": {
          "imagen_activar": this.formLanding.controls['imagen_formulario'].value,
          "configuracion": {
            "width": this.formLanding.controls['imagen_tamanio'].value + "%"
          }
        },
        "configuracion": {
          "background": this.color_formulario_fondo,
          "input": {
            "background": this.color_fondo_input
          }
        }
      },
      "logo": {
        "posicion_id": this.formLanding.controls['posicionLogo'].value,
        "configuracion": {
          "width": this.formLanding.controls['logo_tamanio'].value + "%"
        },
      },
      "titulo": {
        "posicion_id": this.formLanding.controls['posicionTitulo'].value,
        "configuracion": {
          "color": this.colorFuente,
          'fuente_tamanio': this.formLanding.controls['fuente_titulo_tamanio'].value
        },
      },
      "descripcion": {
        "posicion_id": this.formLanding.controls['posicionTextoDescripcion'].value,
        "configuracion": {
          "texto": {
            "bold": this.formLanding.controls['fuente_bold_descripcion'].value,
            "underline": this.formLanding.controls['fuente_subrayar_descripcion'].value,
            "color": this.color_fuente_descripcion,
            "font_size": this.formLanding.controls['fuente_descripcion_tamanio'].value,
          }
        },
      },
      "fondo": {
        "posicion_id": this.formLanding.controls['posicionFondo'].value,
        "configuracion": {
          "background": this.formLanding.controls['sin_fondo'] ? this.background : "none"
        },
      },
      "boton": {
        "posicion_id": this.formLanding.controls['posicionBoton'].value,
        "configuracion": {
          "background": this.colorBoton,
          "color": this.colorFuenteBoton
        }
      },
      "meta": {
        "posicion_id": this.formLanding.controls['posicionMeta'].value,
        "configuracion": {
          "url": this._generalSv.web
        }
      },
      "redes": {
        "posicion_id": this.formLanding.controls['posicionRedesSociales'].value,
        "configuracion": {
          "redes": {
            "twitter": this.color_boton_twitter,
            "instagram": this.color_boton_instagram,
            "facebook": this.color_boton_facebook,
            'web': this.color_boton_web
          }

        }
      },
      "whatsapp": {
        "posicion_id": this.formLanding.controls['posicionBotonWhatsapp'].value,
        "configuracion": {
          "activar": this.formLanding.controls['boton_whatsapp'].value,
          "color": this.color_boton_whatsapp,
          "numero": this.formLanding.controls['numero_contacto_whatsapp'].value,
          "circulo": {
            "width": this.formLanding.controls['circulo_tamanio_whatsapp'].value,
            "height": this.formLanding.controls['circulo_tamanio_whatsapp'].value
          },
          "logo": {
            "width": this.formLanding.controls['logo_whatsapp_tamanio'].value
          }
        }
      },
      "nombre_empresa": {
        "posicion_id": "1",
        "configuracion": {
          "activar": this.formLanding.controls['nombre_empresa'].value,
          "nombre": this.nombre_empresa_string,
          "color": this.color_nombre_empresa,
          "width": this.formLanding.controls['nombre_empresa_tamanio'].value
        }
      },
    };
    const objeto = this.formLanding.controls.redesSociales.value;
    Object.keys(objeto).forEach(key => {
      const valor = objeto[key];
      this.object['landing_redes_sociales'].push({
        "nombre": key,
        "url": valor
      });
    })
    if (this.editar) {
      this._landingSv.editarLanding(
        this.object
      ).subscribe(
        respuesta => {
          this.cargando.pop();
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this._router.navigate(['/logueado/campana-venta']);
        }
      );
    } else {
      this._landingSv.crearLanding(
        this.object
      ).subscribe(
        respuesta => {
          this.cargando.pop();
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this._router.navigate(['/logueado/campana-venta']);
        }
      );

    }
  }

  logo(event) {
    this.logo_width = event + "%";
  }
  fuente(event, tipo) {
    switch (tipo) {
      case 'empresa':
        this.nombre_empresa_tamanio = event + "px";
        break;
      case 'titulo':
        this.formLanding.controls['fuente_titulo_tamanio'].setValue(event)
        break;
    }
  }

  imagen(event) {
    this.imagen_width = event + "%";
  }

  getPosiciones() {
    this._landingSv.getPosiciones("").subscribe((respuesta) => {
      this.posiciones = respuesta.data;
      this.cargando.pop()
    },
      () => {
        this.cargando.pop()
      },
      () => {
        this.cargando.pop()
      }
    )
  }

  // posiciones de los divs
  posicionTitulo: string;
  posicionDescripcion: string;
  posicionFormulario: boolean;
  posicionLogo: string;
  posicionWhatsapp: string = "40px";
  posicionRedes: boolean = true;
  posDiv(param, e) {
    var posicion = e.value ? e.value : e;
    switch (param) {
      case 'titulo':
        // posicion IZquierda de titulo
        if (posicion == 3) {
          this.posicionTitulo = 'flex-start';
        }

        // posicion Derecha de titulo
        else if (posicion == 4) {
          this.posicionTitulo = 'flex-end';

          // posicion Centro titulo
        } else if (posicion == 6) {
          this.posicionTitulo = 'center';

        }
        break;
      case 'formulario':
        // Derecha
        if (posicion == 3) {
          this.posicionFormulario = true;
        }
        // izquierda
        else if (posicion == 4) {
          this.posicionFormulario = false;
        }
        break;
      case 'logo':
        // posicion IZquierda de titulo
        if (posicion == 3) {
          this.posicionLogo = 'flex-start';
        }

        // posicion Derecha de titulo
        else if (posicion == 4) {
          this.posicionLogo = 'flex-end';

          // posicion Centro titulo
        } else if (posicion == 6) {
          this.posicionLogo = 'center';

        }
        break;
      case 'redes':
        // izquierda
        if (posicion == 3) {
          this.posicionRedes = false;
          // derecha
        } else if (posicion == 4) {
          this.posicionRedes = true;
        }
        break;
      case 'whatsapp':
        if (posicion == 3) {
          this.posicionWhatsapp = "";

        } else if (posicion == 4) {
          this.posicionWhatsapp = "40px";
        }
        break;
      case 'texto_descripcion':
        // console.log("entro")
        if (posicion == 3)
          this.posicionDescripcion = "left";
        else if (posicion == 4)
          this.posicionDescripcion = "right";
        else if (posicion == 6)
          this.posicionDescripcion = "center";
        break;

    }
  }
  galeriaImagenes(imagenes): void {
    const dialogRef = this.dialog.open(DialogGaleriaImagenes, {
      // width: '40vw',
      data: this.landing_id
    });
  }

}
@Component({
  selector: 'dialog-galeria-imagenes',
  templateUrl: './dialog-galeria-imagenes.html',
  styleUrls: ['./crear-landing.component.scss']
})
export class DialogGaleriaImagenes {
  constructor(
    private dialogRef: MatDialogRef<DialogGaleriaImagenes>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _landingSv: LandingService,
    public snackBar: MatSnackBar,
  ) {
  }
  cargando: boolean;
  imagenes_new = [];

  ngOnInit() {
    this.getLanding();
  }

  onNoClick() {
    this.dialogRef.close();
    this._landingSv.deleteI.emit();
  }
  // obtengo la landing al editar
  getLanding() {
    this.imagenes_new = [];
    this.cargando = true;
    const model = {
      filtros: {
        id: this.data
      }
    }
    this._landingSv.getLanding(model).subscribe((respuesta) => {
      this.cargando = false;
      respuesta.data[0].imagenes.forEach(element => {
        if (element.tipo == 'carousel') {
          this.imagenes_new.push({
            id: element.id,
            blob: element.blob
          });
        }
      });
      if (this.imagenes_new.length == 0)
        this.onNoClick();
    });
  }

  borrarImagen(id) {
    this.cargando = true;
    const model = {
      id: id
    }
    this._landingSv.eliminarImagen(model).subscribe((respuesta) => {
      this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
      this.cargando = false;
      this.getLanding();
    })
  }
}

